<template>
  <div class="card" @click="goToCoin(coinData.code)">
    <div class="card-header">
      <CoinIcon class="coin-icon" :url="coinData.iconUrl" />
      <!-- <img v-if="coinData.iconUrl" :src="coinData.iconUrl" alt="coin icon" width="34" height="34">
      <img v-else src="@/assets/logo_group.svg" class="fallback-logo" alt="fallback coin icon" width="34" height="34"> -->
      <div class="card-title h5">{{coinData.name}}</div>
      <div class="variation">
        <i class="fa fa-arrow-up" v-if="coinData.worth > coinData.purchasePrice" aria-hidden="true"></i>
        <i class="fa fa-arrow-down" v-if="coinData.worth < coinData.purchasePrice" aria-hidden="true"></i>
        <span :class="{ 'increase': coinData.worth > coinData.purchasePrice, 'decrease': coinData.worth < coinData.purchasePrice }">
          {{helper.getCurrencyString(coinData.worth - coinData.purchasePrice)}}
          ({{helper.getPercentageString((1 - (coinData.purchasePrice / coinData.worth)) * 100)}}%)
        </span>
      </div>
      <!-- <div class="card-subtitle text-gray">Software and hardware</div> -->
    </div>
    <div class="card-body">
      <ul class="stats">
        <li class="text-left">
          <p>{{parseFloat(coinData.amount.toFixed(8))}} <small>{{coinData.code}}</small></p>
          <p><small>coin</small></p>
        </li>
        <li class="text-center">
          <p>{{helper.getCurrencyString(coinData.amount * coinData.price)}} <small>GBP</small></p>
          <p> <small>worth</small></p>
        </li>
        <li class="text-right">
          <p>{{helper.getCurrencyString(parseFloat(coinData.price))}} <small>GBP</small></p>
          <p> <small>unit price</small></p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Router from '@/router';
import Helper from '@/utils/Helper';
import CoinIcon from '@/components/coin/CoinIcon';

export default {
  name: 'AccountCard',
  components: {
    CoinIcon,
  },
  props: [
    'coinData',
  ],
  data() {
    return {
      helper: Helper,
    };
  },
  methods: {
    goToCoin(code) {
      Router.push({ name: 'Coin', params: { code: code.toLowerCase() } });
    },
  },
};
</script>

<style lang="scss" scoped>
  div.card {
    cursor: pointer;
    margin: 0.5rem;

    &:hover {
      // outline: 2px solid #FF9800;
      outline: 2px solid #673AB7;
    }

    .card-header {
      display: flex;
      align-items: center;
      padding: 0.5rem 0.5rem 0 0.5rem;

      .coin-icon {
        margin-right: 0.5rem;
      }

      .variation {
        position: absolute;
        right: 0;
        margin-right: 1rem;

        .increase, .fa-arrow-up {
          color: #4CAF50;
        }

        .decrease, .fa-arrow-down {
          color: #f44336;
        }
      }
    }

    .card-body {
      display: flex;
      justify-content: space-between;
      padding: 0.5rem;

      ul.stats {
        display: flex;
        width: 100%;
        margin: 0;

        & > li {
          display: flex;
          flex-direction: column;
          text-align: center;
          width: 33.33%;

          p {
            margin: 0;

            &:nth-child(2) {
              color: #9E9E9E;
            }
          }
        }
      }
    }

  }
</style>




// WEBPACK FOOTER //
// src/components/card/CoinCard.vue